import { Component } from "react";
import { Action, Dispatch } from "redux";
import { connect } from "react-redux"
import { HashRouter as Router, Redirect, Route, RouteComponentProps, Switch } from "react-router-dom"
import { AppState } from "./AppState"
import RandomPools from "./components/Randomization/RandomPools"
import RandomGovPools from "./components/Randomization/GovPools/RandomGovPools"
import GovDonor from "./components/GovDonor/GovDonorGrid"
import OrderRequest from "./components/OrderRequests/OrderRequest"
import OrderFinish from "./components/OrderRequests/OrderFinish"
import OrderResults from "./components/OrderResults/OrderTracking"
import SiteSearchPage from "./components/SiteSearch/SiteSearchPage"
import "./App.scss"
import ConnectedWorkforce1Login from "./authentication/Workforce1Login"
import ConnectedSSOWorkforce1Login from "./authentication/SSOWorkforce1Login"
import PageLoading from "./components/PageLoading"
import { PageLoaded } from "./actions/WorkforceOnePageActions"
import ClinicSearchOptions from "./components/Administration/ClinicSearchOptions"
import ConnectedCompanySelection from "./components/Companies/CompanySelection"
import RandomPersonnelGrid from "./components/Randomization/RandomPersonnelGrid"
import SelectionInbox from "./components/Randomization/SelectionInbox"
import MyInformation from "./components/Accounts/MyInformation"
import UserDetailsGrid from "./components/Administration/UserDetailsGrid"
import UserActivation from "./components/Administration/UserActivation"
import RegulatoryModeForm from "./components/Accounts/RegulatoryMode/RegulatoryModeForm"
import CompanyActivation from "./components/Administration/CompanyActivation"
import PortalActivation from "./components/Administration/PortalActivation"
import CompanyInformation from "./components/Administration/CompanyInformation"
import LocationInformation from "./components/Administration/LocationInformation"
import MyOrganization from "./components/Administration/MyOrganization"
import OrphanedResults from "./components/OrphanedResults/OrphanedResults"
import InvitationStatusGrid from "./components/InvitationStatus/InvitationStatusGrid"
import GlobalParameter from "./components/Administration/GlobalParameter"
import OrderableServicesModal from "./components/Administration/OrderableServicesModal"
import UserCodesModal from "./components/Administration/UserCodesModal"
import UserLabelsModal from "./components/Administration/UserLabelsModal"
import LabResultsReportingModal from "./components/Administration/LabResultsReportingModal"
import {
  Home,
  WorkforceOnePswUpdate,
  OrderFinishRoute,
  OrderRoute,
  OrdersRoute,
  RandomsPersonnelRoute,
  RandomsRoute,
  SelectionInboxRoute,
  SiteSearchOptionsRoute,
  SiteSearchRoute,
  ActivateCompanyRoute,
  ActivatePortalRoute,
  MyOrganizationRoute,
  MyOrganizationNameRoute,
  CompanyInformationRoute,
  LocationInformationRoute,
  InviteStatusRoute,
  MyInformationRoute,
  OrphanedResultsRoute,
  OurTeamStatusRoute,
  RegulatoryModeRoute,
  PermissionsRoute,
  LegacyWorkforceUserInvitationRoute,
  LegacyWorkforcePortalInvitationRoute,
  LegacyWorkforceCompanyInvitationRoute,
  GlobalParameterRoute,
  OrderableServicesRoute,
  UserCodesRoute,
  WorkforceOnePswConfigureRoute,
  GovDonorRoute,
  RandomsGovRoute,
  GovOrderRoute,
  SSOOrderRoute,
  SSOOrderFinishRoute,
  SSOSiteSearchRoute,
  SSOGetAuthFormRoute,
  SSOHome,
  SSOCallbackRoute,
  ReportPositiveRoute,
  ReportTestingSummaryRoute,
  ReportDrugDetailRoute,
  ReportDailySummaryRoute,
  ReportSpecimenPositivityRoute,
  ReportIvrCallInComplianceRoute,
  ReportNoShowRoute,
  UserLabelsRoute,
  ReportCertificationRenewalRoute,
  ReportCertificationStatusRoute,
  ReportManagementSummaryRoute,
  ReportMISRoute,
  ReportSummaryRoute,
  PortalAdministrationRoute,
  AddNewPortalRoute,
  ActivateUserRoute,
  ConfigureOrderDefaultsRoute,
  AddNewCompanyRoute,
  AddNewCompanyNameRoute,
  SendingFacilityRoute,
  ConsortiumsRoute,
  ConsortiumPersonnelRoute,
  CompanyInformationNameRoute,
  ReportSelectedNotTestedRoute,
  LabResultsReportingRoute,
  ReportUnmergedRandomResultsRoute,
  ReportRegulatoryQualityControlRoute,
  ReportMissingRegModeOrEmpCategoryRoute
} from "./config/Routes"
import InvitationProcess from "./components/Invitation/InvitationProcess"
import PasswordResetLanding from "./components/Secuirty/PasswordResetLanding";
import Permissions from "./components/Administration/Permissions"
import UserAccessSettings from "./authentication/UserAccessSettings"
import { BuildUserAccess } from "./authentication/BuildUserAccess"
import UserState from "./authentication/UserState"
import { BuildUserState } from "./authentication/BuildUserState"
import ProtectedRoute from "./components/ProtectedRoute"
import { GetUserDefaultRoute } from "./authentication/GetUserDefaultRoute";
import GovOrderRequest from "./components/OrderRequests/GovOrderRequest";
import SSOSiteSearchPage from "./components/sso/SiteSearchPage";
import SSOGetAuthFormPage from "./components/sso/GetAuthFormPage";
import SSOCallback from "./authentication/SSOCallback"
import { GetAuthToken } from "./storage/AuthToken";
import ReportParameters from "./components/Reports/ReportParameters";
import { ImplementationTypeGovt, StorageKey } from "./config/Constants";
import PortalGrid from "./components/Invitation/Portal/PortalGrid";
import AddNewPortal from "./components/Invitation/Portal/AddNewPortal";
import { AppPageWrapper } from "./components/NavMenu/AppPageWrapper"
import ProcessingModal from "./components/ProcessingModal"
import packageJson from '../package.json'
import WorkforceReportParameters from "./components/Reports/WorkforceReportParameters";
import SummaryReport from "./components/Reports/SummaryReport/SummaryReport";
import OrderDefaults from "./components/Administration/OrderDefaults";
import PortalSelectionModal from "./components/Companies/PortalSelectionModal";
import AddNewCompany from "./components/Invitation/AddNewCompany";
import RequireCompleteSetupModal from "./components/Invitation/RequireCompleteSetupModal"
import LogErrorToServer from "./api/Logging/LogErrorToServer";
import { Button } from "react-bootstrap";
import SendingFacilityPage from "./components/Administration/SendingFacilityPage";
import ConsortiumPools from "./components/Randomization/ConsortiumPools";
import ConsortiumPersonnel from "./components/Randomization/ConsortiumPersonnel";
import PositiveReport from "./components/Reports/PositiveReport";
import UnmergedRandomResultsReport from "./components/Reports/UnmergedRandomResultsReport/UnmergedRandomResultsReport";
import RegulatoryQualityControlReport from "./components/Reports/RegulatoryQualityControlReport/RegulatoryQualityControlReport";
import MissingRegModeOrEmployeeCategoryReport from "./components/Reports/MissingRegModeOrEmployeeCategoryReport/MissingRegModeOrEmployeeCategoryReport";



require('source-map-support').install({
  handleUncaughtExceptions: false
});

export interface GlobalAppStateProps {
  PageLoading: boolean
  loadedUserPermission: boolean
  selectedCompany: boolean
  authenticated: boolean
  requireCompleteSetup: boolean
  userAccess: UserAccessSettings
  userState: UserState
  loadingCompany?: string
  link: string
  wrongUrl: boolean
  showCompanySelection: boolean
}
export interface AppStateDispatchProps {
  pageLoaded: () => void
}

export function IsOnTrack() {
  return sessionStorage.getItem(StorageKey.ImplementationType) === ImplementationTypeGovt
}

interface GlobalAppState {
  error?: Error
}
export type AppProps = GlobalAppStateProps & AppStateDispatchProps;
export class App extends Component<AppProps, GlobalAppState>{
  state: GlobalAppState = { error: undefined }

  constructor(props: AppProps) {
    super(props)
    this.props.pageLoaded()
    this.checkAppVersionAndReload()
  }

  checkAppVersionAndReload = () => {
    const appVersion = packageJson.version
    fetch('meta.json')
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version
        const currentVersion = appVersion
        const shouldForceRefresh = this.appVerGreaterThan(latestVersion, currentVersion)
        if (shouldForceRefresh) {
          this.loadNewAppVersion()
        }
      })
  }

  appVerGreaterThan = (latestVersion: string, currentVersion: string) => {
    const versionsA = latestVersion.split(/\./g)
    const versionsB = currentVersion.split(/\./g)

    while (versionsA.length || versionsB.length) {
      const a = Number(versionsA.shift())
      const b = Number(versionsB.shift())

      if (a === b) continue
      return a > b || isNaN(b)
    }
    return false
  }

  loadNewAppVersion = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(async (name) => {
          await caches.delete(name)
        })
      })
      location.reload()
    }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ error: error })
    LogErrorToServer(error, info);
  }

  render() {
    const token = GetAuthToken()
    const { authenticated, selectedCompany, userAccess, userState, requireCompleteSetup, wrongUrl, showCompanySelection } = this.props
    const authenticatedAndCompanySelected = this.props?.authenticated && this.props?.selectedCompany
    const authenticatedAndSelectedAndUserAccessLoaded = authenticatedAndCompanySelected && this.props?.loadedUserPermission

    if (!!token && !(authenticated && !selectedCompany) && (!this.props?.loadedUserPermission || this.props.loadingCompany)) {
      return <AppPageWrapper showNav={true}>
        <ProcessingModal message="Loading..." />
      </AppPageWrapper>
    }

    return <>
      <Router>
        <Switch>
          {this.state.error && <Route path='*' exact render={() =>
            <AppPageWrapper showNav={false}>
              <div role="alert">
                <p>Something went wrong:</p>
                <pre>{this.state.error?.message}</pre>
                <Button variant="primary" onClick={() => location.reload()}>Try again</Button>
              </div>
            </AppPageWrapper>
          } />}
          <Route path={SSOHome} exact component={ConnectedSSOWorkforce1Login} />
          {/* Invitation process */}
          <Route exact path={LegacyWorkforceUserInvitationRoute + "/:linkId?"} render={(props) => <InvitationProcess linkId={props.match.params.linkId} {...(props as RouteComponentProps)} />} />
          <Route exact path={LegacyWorkforceCompanyInvitationRoute + "/:linkId?"} render={(props) => <InvitationProcess linkId={props.match.params.linkId} {...(props as RouteComponentProps)} />} />
          <Route exact path={LegacyWorkforcePortalInvitationRoute + "/:linkId?"} render={(props) => <InvitationProcess linkId={props.match.params.linkId} {...(props as RouteComponentProps)} />} />
          <Route exact path={WorkforceOnePswConfigureRoute + "/:linkId?"} render={(props) => <InvitationProcess linkId={props.match.params.linkId} {...(props as RouteComponentProps)} />} />
          <Route exact path={WorkforceOnePswUpdate + "/:linkId/:linkTime/:username"}
            render={(props) =>
              <PasswordResetLanding linkId={props.match.params.linkId}
                linkTime={props.match.params.linkTime}
                userName={props.match.params.username} />} />

          {authenticated && requireCompleteSetup && <Route path='*' component={RequireCompleteSetupModal} />}
          {authenticated && wrongUrl && <Route path='*' component={PortalSelectionModal} />}
          {/* Authorized user routes */}
          <ProtectedRoute exact path={MyInformationRoute} component={MyInformation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={InviteStatusRoute} component={InvitationStatusGrid} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={RandomsRoute} component={RandomPools} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={RandomsPersonnelRoute} component={RandomPersonnelGrid} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SelectionInboxRoute} component={SelectionInbox} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={OrderRoute} component={OrderRequest} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={OrderFinishRoute} component={OrderFinish} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SiteSearchRoute} component={SiteSearchPage} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={OrdersRoute} component={OrderResults} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={OurTeamStatusRoute} component={UserDetailsGrid} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={CompanyInformationRoute} component={CompanyInformation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={LocationInformationRoute} component={LocationInformation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ActivateUserRoute} component={UserActivation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={OrphanedResultsRoute} component={OrphanedResults} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={MyOrganizationRoute} component={MyOrganization} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={AddNewPortalRoute} component={AddNewPortal} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={MyOrganizationNameRoute} component={MyOrganization} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={CompanyInformationNameRoute} component={CompanyInformation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={AddNewCompanyRoute} component={AddNewCompany} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={AddNewCompanyNameRoute} component={AddNewCompany} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={PortalAdministrationRoute} component={PortalGrid} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ActivateCompanyRoute} component={CompanyActivation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SiteSearchOptionsRoute} component={ClinicSearchOptions} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={GlobalParameterRoute} component={GlobalParameter} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ActivatePortalRoute} component={PortalActivation} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={RegulatoryModeRoute} component={RegulatoryModeForm} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={PermissionsRoute} component={Permissions} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={OrderableServicesRoute} component={OrderableServicesModal} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={UserCodesRoute} component={UserCodesModal} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={RandomsGovRoute} component={RandomGovPools} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ConsortiumsRoute} component={ConsortiumPools} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ConsortiumPersonnelRoute} component={ConsortiumPersonnel} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={GovDonorRoute} component={GovDonor} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={GovOrderRoute} component={GovOrderRequest} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SSOOrderRoute} component={OrderRequest} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SSOOrderFinishRoute} component={OrderFinish} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SSOSiteSearchRoute} component={SSOSiteSearchPage} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SSOGetAuthFormRoute} component={SSOGetAuthFormPage} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportPositiveRoute} component={PositiveReport} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportTestingSummaryRoute} component={ReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportDrugDetailRoute} component={ReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportDailySummaryRoute} component={ReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportSpecimenPositivityRoute} component={ReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportIvrCallInComplianceRoute} component={ReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportNoShowRoute} component={ReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={UserLabelsRoute} component={UserLabelsModal} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportCertificationRenewalRoute} component={WorkforceReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportCertificationStatusRoute} component={WorkforceReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportManagementSummaryRoute} component={WorkforceReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportMISRoute} component={WorkforceReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportSelectedNotTestedRoute} component={WorkforceReportParameters} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportSummaryRoute} component={SummaryReport} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportUnmergedRandomResultsRoute} component={UnmergedRandomResultsReport} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ConfigureOrderDefaultsRoute} component={OrderDefaults} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={SendingFacilityRoute} component={SendingFacilityPage} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={LabResultsReportingRoute} component={LabResultsReportingModal} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportRegulatoryQualityControlRoute} component={RegulatoryQualityControlReport} userAccess={userAccess} userState={userState} />
          <ProtectedRoute exact path={ReportMissingRegModeOrEmpCategoryRoute} component={MissingRegModeOrEmployeeCategoryReport} userAccess={userAccess} userState={userState} />
          
          {/* Loading and Company selection */}
          {this.props?.PageLoading && <Route path='*' exact render={() => <PageLoading message={"Loading.."} />} />}
          {authenticated && !selectedCompany && showCompanySelection && <Route path='*' exact render={() => <ConnectedCompanySelection />} />}
          {authenticatedAndCompanySelected && !this.props?.loadedUserPermission && <Route path='*' exact render={() => <PageLoading showNav delayedVisibility message={"Loading Users Profile.."} />} />}

          {/* Authorized user's Default page */}
          {authenticatedAndSelectedAndUserAccessLoaded && <Route path='*' exact render={() => <Redirect to={GetUserDefaultRoute(userAccess, userState)} />} />}

          {/* Login page and redirect to Home */}
          {/*<Route path={AboutRoute} exact component={About} />*/}
          {!authenticated && <Route path={Home} exact render={() => <ConnectedWorkforce1Login />} />}
          <Route path='*' exact render={(props: RouteComponentProps) => {
            const path = props?.location?.pathname || ""
            if (path.startsWith("/access_token=")) {
              return <SSOCallback {...props} />
            } else {
              return <Redirect to={Home} />
            }
          }
          } />
        </Switch>
      </Router>
    </>
  }
}
function mapStateToProps(state: AppState): GlobalAppStateProps {
  return {
    PageLoading: state.Workforce1State.isLoading ?? true,
    loadedUserPermission: state.Workforce1State.loadedSelectedCompanyPermission,
    selectedCompany: !!state.Workforce1State.selectedCompany,
    authenticated: !!state.Workforce1State && state.Workforce1State.isLoggedIn,
    requireCompleteSetup: !!state.Workforce1State.requireCompleteSetup,
    link: state.Workforce1State.link || "",
    userAccess: BuildUserAccess(state),
    userState: BuildUserState(state),
    showCompanySelection: state.Workforce1State.showCompanySelection,
    loadingCompany: state.Workforce1State.loadingCompany,
    wrongUrl: !!state.Workforce1State.loginResultMessage // Copied this logic from an Angular app: the presence of a message means there's an invalid url
  }
}
function mapDispatchProps(dispatch: Dispatch<Action>): AppStateDispatchProps {
  return {
    pageLoaded: () => dispatch(PageLoaded()),
  }
}

const ConnectedApp = connect<GlobalAppStateProps, AppStateDispatchProps, {}, AppState>(mapStateToProps, mapDispatchProps)(App)
export default ConnectedApp
